export default class GamePeriodChangeError extends Error {
    constructor() {
        super("Invalid game period change");
    }
}
